"use client";

import Link from "next/link";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    // Log to console — in production this can be wired to an external collector.
    // Keep it minimal so we don't leak data. Server-side errors are logged by Next anyway.
    console.error("[parks] caught render error:", error);
  }, [error]);

  return (
    <div className="mx-auto w-full max-w-xl space-y-5 px-margin-mobile py-20 text-center md:px-margin-desktop">
      <h1 className="font-display-lg text-display-lg text-primary">Something went wrong rendering this page.</h1>
      <p className="font-body-md text-body-md text-on-surface-variant">
        The error has been logged. The data behind it is fine. Try reloading, or step back to the map.
      </p>
      {error.digest && <p className="text-xs text-muted-foreground font-mono">Error id: {error.digest}</p>}
      <div className="flex justify-center gap-3">
        <Button onClick={() => reset()}>Try again</Button>
        <Link href="/"><Button variant="outline">Home</Button></Link>
        <Link href="/map"><Button variant="ghost">Open the map</Button></Link>
      </div>
    </div>
  );
}
